import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { IContentItemClass } from '@zmedia/bm-soccer-ui/interface';
import { ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { useAsyncFn } from '@zmedia/bm-soccer-ui/hooks';
import PageService from '@zmedia/bm-soccer-ui/service/PageService';
import { TeamStanding } from './standing';
import { TeamNews } from './news';
import { TeamSquad } from './squad';
import { TeamMatches } from './matches';
import { TeamOverview } from './overview';
import { PageTeamWrap } from '../components';
import { TeamTransfer } from './transfer';
import { TAB_IDS } from '../../shared';

export function TeamPageView({
    content,
    otherData = {},
    listProps,
}: {
    content: any;
    otherData: any;
    listProps: any;
}) {
    const router = useRouter();
    let data = content;
    const { id } = router.query;

    if (ObjectUtils.isEmpty(data)) {
        const [state, callback] = useAsyncFn(PageService.getTeamDetail);
        useEffect(() => {
            callback(id);
        }, [id]);
        data = state.value?.data || {};
    }

    if (ObjectUtils.isEmpty(data)) {
        return null;
    }

    const renderTabs = () => {
        switch (data.activeTab) {
            case TAB_IDS.STANDING:
                return <TeamStanding {...data} {...otherData} />;
            case TAB_IDS.NEWS:
                return (
                    <TeamNews
                        {...data}
                        {...otherData}
                        listProps={Object.assign({}, listProps, {
                            ContentItemClass: {
                                CardClass: 'max-md:flex-row',
                                CardContentClass: "max-md:ml-[15px] md:mt-[7px]",
                                CardImageClass: 'md:w-full',
                            } as IContentItemClass,
                        })}
                    />
                );
            case TAB_IDS.SQUAD:
                return <TeamSquad {...data} {...otherData} />;
            case TAB_IDS.MATCHES:
                return <TeamMatches {...data} {...otherData} />;
            case TAB_IDS.TRANSFER:
                return <TeamTransfer {...data} {...otherData} />;
            default:
                return <TeamOverview {...data} {...otherData} />;
        }
    };

    return <PageTeamWrap {...data}>{renderTabs()}</PageTeamWrap>;
}

export default TeamPageView;
